"use client";
import Link from "next/link";
import React, { useState } from "react";
type Props = {
  style: string;
};
type DropdownState = {
  home: boolean;
  pages: boolean;
  shop: boolean;
  blog: boolean;
};
const NavSection = ({ style }: Props) => {
  const [dropdown, setDropdown] = useState<DropdownState>({
    home: false,
    pages: false,
    shop: false,
    blog: false,
  });

  const handleToggleDropdown = (dropdownName: keyof DropdownState) => {
    if (window.innerWidth < 992) {
      setDropdown((prevState) => ({
        ...prevState,
        [dropdownName]: !prevState[dropdownName],
      }));
    }
  };

  return (
    <div className={`rv-1-header__nav ${style}`}>
      <ul className="justify-content-center">
        <li className={dropdown.home ? "rv-dropdown-active" : ""}>
          <a href="/">Home</a>
        </li>

        <li>
          <Link href="/about">About</Link>
        </li>

        <li className={dropdown.pages ? "rv-dropdown-active" : ""}>
          <a role="button" onClick={() => handleToggleDropdown("pages")}>
            Products
          </a>
          <ul className="sub-menu">
            <li>
              <Link href="/products/millets">Millets</Link>
            </li>
            {/* <li>
              <Link href="/services/web-solution">Example2</Link>
            </li>
            <li>
              <Link href="/services/web-solution">Example3</Link>
            </li>
            <li>
              <Link href="/services/web-solution">Example4</Link>
            </li>
            <li>
              <Link href="/services/web-solution">Example5</Link>
            </li> */}
          </ul>
        </li>
        {/* <li>
          <Link href="/overview">Overview</Link>
        </li> */}
        <li>
          <Link href="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
};

export default NavSection;
